/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorConsequenceModel } from '../../models/patient-behavior-consequence-model';

export interface SavePatientBehaviorConsequence$Params {
      body?: PatientBehaviorConsequenceModel
}

export function SavePatientBehaviorConsequence(http: HttpClient, rootUrl: string, params?: SavePatientBehaviorConsequence$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorConsequenceModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBehaviorConsequence.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBehaviorConsequenceModel>;
    })
  );
}

SavePatientBehaviorConsequence.PATH = '/api/Staff/SavePatientBehaviorConsequence';
